import axios from "axios";
import {detailServicesPath} from "../../Constants";

const restUrl = detailServicesPath + '/organizations/composition-replacements'

export default class CompositionReplacementService {
    static async getAll(compositionId) {
        return axios.get(restUrl + '?compositionId=' + compositionId);
    }

    static async create(compositionId, data) {
        return await axios.post(restUrl + '?compositionId=' + compositionId, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async update(id, data) {
        return await axios.put(restUrl + '/' + id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
